(() => {
  const STORAGE_KEY = 'massaro:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
      /* localStorage unavailable (private mode, disabled storage) */
    }
  }

  function paint(button, isActive) {
    button.setAttribute('aria-pressed', String(isActive));
    button.classList.toggle('is-active', isActive);
  }

  function refresh() {
    const wishlist = getWishlist();
    document.querySelectorAll('[data-massaro-wishlist]').forEach((button) => {
      paint(button, wishlist.includes(button.dataset.massaroWishlist));
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-massaro-wishlist]');
    if (!button) return;

    event.preventDefault();
    const id = button.dataset.massaroWishlist;
    const wishlist = getWishlist();
    const index = wishlist.indexOf(id);

    if (index > -1) {
      wishlist.splice(index, 1);
      paint(button, false);
    } else {
      wishlist.push(id);
      paint(button, true);
    }

    setWishlist(wishlist);
  });

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
